const deepMerge = function() {
    var args = Array.prototype.slice.call(arguments);
    if (args.length === 0)
        return {};
    if (typeof this.isObject === 'undefined') {
        this.isObject = function(arg) { return (arg !== false && (typeof arg === 'function' || typeof arg === 'object')); };
        this.isArray = function(arg) { return (Object.prototype.toString.call(arg) === '[object Array]'); };
    }
    var merged = Object.assign({}, args.shift());
    for (var i = 0; i < args.length; i++) {
        for (var key in args[i]) {
            if (args[i].hasOwnProperty(key)) {
                if (this.isObject(args[i][key]) && !this.isArray(args[i][key]) && merged.hasOwnProperty(key) && this.isObject(merged[key]))
                    merged[key] = Object.deepMerge(merged[key], args[i][key]);
                else if (this.isArray(args[i][key]) && merged.hasOwnProperty(key) && this.isArray(merged[key]))
                    merged[key] = merged[key].concat(args[i][key]);
                else {
                    if (this.isObject(args[i][key]))
                        args[i][key] = Object.assign({}, args[i][key]);
                    merged[key] = args[i][key];
                }
            }
        }
    }
    return merged;
};

module.exports = deepMerge;
